import { useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import IndexSection from './components/IndexSection';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import FaqSection from './components/FaqSection';
import CommentsSection from './components/CommentsSection';
import AppSection from './components/AppSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      section[id], footer[id] {
        scroll-margin-top: 64px;
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <FeaturesSection />
        <UpdatesSection />
        <TopicsSection />
        <IndexSection />
        <CarouselSection />
        <AboutSection />
        <RankingSection />
        <CardsSection />
        <ContactSection />
        <FaqSection />
        <CommentsSection />
        <AppSection />
        <MediaSection />
      </main>
      <Footer />
    </div>
  );
}